export const createUserPrivateDataService = ({
  supabase,
  tableName,
  sessionUserId,
  starterUserId,
  isMissingRelationError,
  onMissingRelationError,
}) => {
  const load = async (dataKey, _localStorageKey, fallbackValue) => {

    if (!sessionUserId || !supabase) {
      return { found: false, value: fallbackValue, source: "fallback" };
    }

    try {
      const { data, error } = await supabase
        .from(tableName)
        .select("data")
        .eq("user_id", sessionUserId)
        .eq("data_key", dataKey)
        .maybeSingle();

      if (error) {
        if (isMissingRelationError(error)) {
          onMissingRelationError?.();
          return { found: false, value: fallbackValue, source: "fallback" };
        }
        throw error;
      }

      if (!data) {
        if (starterUserId && starterUserId !== sessionUserId) {
          const { data: starterData, error: starterError } = await supabase
            .from(tableName)
            .select("data")
            .eq("user_id", starterUserId)
            .eq("data_key", dataKey)
            .maybeSingle();

          if (!starterError && starterData) {
            void save(dataKey, starterData.data);
            return { found: true, value: starterData.data, source: "cloud" };
          }
        }

        return { found: false, value: fallbackValue, source: "fallback" };
      }

      return { found: true, value: data.data, source: "cloud" };
    } catch (error) {
      console.error("Fehler beim Laden privater Nutzerdaten:", error);
      return { found: false, value: fallbackValue, source: "fallback" };
    }
  };

  const save = async (dataKey, value) => {
    if (!sessionUserId || !supabase) return false;

    try {
      const { error } = await supabase
        .from(tableName)
        .upsert(
          {
            user_id: sessionUserId,
            data_key: dataKey,
            data: value,
            updated_at: new Date().toISOString(),
          },
          { onConflict: "user_id,data_key" }
        );

      if (error) {
        if (isMissingRelationError(error)) {
          onMissingRelationError?.();
          return false;
        }
        throw error;
      }

      return true;
    } catch (error) {
      console.error("Fehler beim Speichern privater Nutzerdaten:", error);
      return false;
    }
  };

  const saveDetailed = async (dataKey, value) => {
    if (!sessionUserId || !supabase) {
      return { ok: false, error: { message: "Nicht angemeldet oder Supabase nicht konfiguriert." } };
    }

    try {
      const { error } = await supabase
        .from(tableName)
        .upsert(
          {
            user_id: sessionUserId,
            data_key: dataKey,
            data: value,
            updated_at: new Date().toISOString(),
          },
          { onConflict: "user_id,data_key" }
        );

      if (error) {
        return { ok: false, error };
      }

      return { ok: true, error: null };
    } catch (error) {
      return { ok: false, error };
    }
  };

  return {
    load,
    save,
    saveDetailed,
  };
};
